import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteCategoryModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteCategoryModalContainer" */
      './DeleteCategoryModalContainer'
    ),
  loading: LoadingModal,
});
